import { render, staticRenderFns } from "./PaymentsAudit.vue?vue&type=template&id=f580c32c&scoped=true"
import script from "./PaymentsAudit.vue?vue&type=script&lang=js"
export * from "./PaymentsAudit.vue?vue&type=script&lang=js"
import style0 from "./PaymentsAudit.vue?vue&type=style&index=0&id=f580c32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f580c32c",
  null
  
)

export default component.exports